import React, { useState, useEffect } from 'react';

function KiemTraNhapHang() {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem('token'));
  const [loginInfo, setLoginInfo] = useState({ TenUser: '', Password: '' });
  const [loginError, setLoginError] = useState('');
  const [ngayNhap, setNgayNhap] = useState(() => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  });
  const [maCH, setMaCH] = useState(localStorage.getItem('IDCH') || '');
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [soLuongThucNhan, setSoLuongThucNhan] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Đăng nhập
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    // Nếu là admin đặc biệt thì không gọi API
    if (
      loginInfo.TenUser === 'admin' &&
      loginInfo.Password === 'dongtien@admin'
    ) {
      localStorage.setItem('token', 'admin-token');
      localStorage.setItem('TenUser', 'admin');
      localStorage.setItem('IDCH', '');
      setMaCH('');
      setLoggedIn(true);
      setIsAdmin(true);
      return;
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginInfo)
      });
      const result = await res.json();
      if (!res.ok) {
        setLoginError(result.message || 'Đăng nhập thất bại');
        return;
      }
      localStorage.setItem('token', result.token);
      localStorage.setItem('TenUser', result.user.TenUser);
      localStorage.setItem('IDCH', result.user.IDCH);
      setMaCH(result.user.IDCH);
      setLoggedIn(true);
      // Kiểm tra quyền admin
      if (
        loginInfo.TenUser === 'admin' &&
        loginInfo.Password === 'dongtien@admin'
      ) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    } catch (err) {
      setLoginError('Lỗi kết nối server');
    }
  };

  // Khi reload lại trang, kiểm tra nếu là admin thì cho phép sửa mã cửa hàng
  useEffect(() => {
    const TenUser = localStorage.getItem('TenUser');
    const IDCH = localStorage.getItem('IDCH');
    if (TenUser === 'admin') {
      setIsAdmin(true);
    }
    if (IDCH) setMaCH(IDCH);
  }, []);

  // Gọi API kiểm tra nhập hàng
  const fetchNhapHang = async () => {
    setFetching(true);
    setFetchError('');
    setData([]);
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/sale-nhap-hang?MaCH=${maCH}&NgayNhap=${ngayNhap}`;
      const token = localStorage.getItem('token');
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) {
        setFetchError('Không lấy được dữ liệu');
        setFetching(false);
        return;
      }
      const result = await res.json();
      setData(result);
      // Reset số lượng thực nhận = số lượng
      const sltn = {};
      (result || []).forEach(row => { sltn[row.MaSP] = row.SoLuong; });
      setSoLuongThucNhan(sltn);
    } catch (err) {
      setFetchError('Lỗi kết nối server');
    }
    setFetching(false);
  };

  // Xử lý nhập số lượng thực nhận
  const handleSLThucNhanChange = (MaSP, value) => {
    setSoLuongThucNhan(prev => ({ ...prev, [MaSP]: value }));
  };

  // Đăng xuất
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('TenUser');
    localStorage.removeItem('IDCH');
    setLoggedIn(false);
    setData([]);
    setLoginInfo({ TenUser: '', Password: '' });
    setIsAdmin(false);
  };

  // Gửi phiếu cập nhật số lượng thực nhận
  const handleSubmitPhieu = async () => {
    setSubmitError('');
    setSubmitSuccess('');
    setSubmitting(true);

    // Lọc ra các dòng có số lượng thực nhận thay đổi
    const changedRows = (data || []).filter(row => {
      return String(soLuongThucNhan[row.MaSP]) !== String(row.SoLuong);
    }).map(row => ({
      MaSP: row.MaSP,
      SoLuongThucNhan: Number(soLuongThucNhan[row.MaSP])
    }));

    if (changedRows.length === 0) {
      setSubmitError('Không có thay đổi để gửi.');
      setSubmitting(false);
      return;
    }

    // Lấy MaPN từ data (giả sử tất cả cùng MaPN)
    const MaPN = data[0]?.MaPN;
    if (!MaPN) {
      setSubmitError('Không tìm thấy mã phiếu nhập.');
      setSubmitting(false);
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/update-nhap-hang-so-luong`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          MaPN,
          chiTiet: changedRows
        })
      });
      const result = await res.json();
      if (!res.ok) {
        setSubmitError(result.message || 'Gửi phiếu thất bại');
      } else {
        setSubmitSuccess('Gửi phiếu thành công!');
        // Sau khi gửi thành công, cập nhật lại data để đồng bộ số lượng
        fetchNhapHang();
      }
    } catch (err) {
      setSubmitError('Lỗi kết nối server');
    }
    setSubmitting(false);
  };

  // Nếu chưa đăng nhập
  if (!loggedIn) {
    return (
      <div className="container mt-5" style={{maxWidth: 400}}>
        <h3 className="mb-3">Đăng nhập</h3>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Tên đăng nhập</label>
            <input className="form-control" required
              value={loginInfo.TenUser}
              onChange={e => setLoginInfo({ ...loginInfo, TenUser: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Mật khẩu</label>
            <input className="form-control" type="password" required
              value={loginInfo.Password}
              onChange={e => setLoginInfo({ ...loginInfo, Password: e.target.value })}
            />
          </div>
          {loginError && <div className="alert alert-danger py-1">{loginError}</div>}
          <button className="btn btn-primary w-100" type="submit">Đăng nhập</button>
        </form>
      </div>
    );
  }

  return (
    <div className="container mt-4" style={{maxWidth: 900}}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Kiểm tra phiếu nhập hàng</h3>
        <button className="btn btn-outline-secondary btn-sm" onClick={handleLogout}>Đăng xuất</button>
      </div>
      <form className="row g-3 align-items-end mb-3" onSubmit={e => { e.preventDefault(); fetchNhapHang(); }}>
        <div className="col-auto">
          <label className="form-label">Mã cửa hàng</label>
          <input className="form-control"
            value={maCH}
            onChange={e => setMaCH(e.target.value)}
            required
            style={{width: 100}}
            readOnly={!isAdmin}
          />
        </div>
        <div className="col-auto">
          <label className="form-label">Ngày nhập</label>
          <input className="form-control"
            type="date"
            value={ngayNhap}
            onChange={e => setNgayNhap(e.target.value)}
            required
            style={{width: 160}}
          />
        </div>
        <div className="col-auto">
          <button className="btn btn-success" type="submit" disabled={fetching}>
            {fetching ? 'Đang tải...' : 'Kiểm tra'}
          </button>
        </div>
      </form>
      {fetchError && <div className="alert alert-danger py-2 mb-3">{fetchError}</div>}
      {submitError && <div className="alert alert-danger py-2 mb-3">{submitError}</div>}
      {submitSuccess && <div className="alert alert-success py-2 mb-3">{submitSuccess}</div>}
      {data && data.length > 0 ? (
        <>
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Mã Hàng</th>
                  <th>Tên SP</th>
                  <th>Số Lượng</th>
                  <th>Số lượng thực nhận</th>
                  <th>Giá bán</th>
                  <th>Thành tiền</th>
                </tr>
              </thead>
              <tbody>
                {data.map(row => {
                  const slThucNhan = soLuongThucNhan[row.MaSP] ?? '';
                  const isDiff = String(slThucNhan) !== String(row.SoLuong);
                  return (
                    <tr key={row.MaSP} className={isDiff ? 'table-warning' : ''}>
                      <td>{row.MaSP}</td>
                      <td>{row.TenSP}</td>
                      <td>{row.SoLuong}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          style={{width: 100}}
                          value={slThucNhan}
                          onChange={e => handleSLThucNhanChange(row.MaSP, e.target.value)}
                          min={0}
                        />
                      </td>
                      <td>{row.GiaMua}</td>
                      <td>{row.ThanhTien}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="mt-3">
            <button
              className="btn btn-primary"
              onClick={handleSubmitPhieu}
              disabled={submitting}
            >
              {submitting ? 'Đang gửi...' : 'Gửi phiếu'}
            </button>
          </div>
        </>
      ) : fetching ? null : (
        <div className="text-muted">Không có dữ liệu.</div>
      )}
    </div>
  );
}

export default KiemTraNhapHang;
